/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { ColorBlock } from "src/classes/block/block-types";
import { Plate } from "src/classes/plate/Plate";
import { ColorPicker, StyledColorBlockContent } from "src/components/Block/BlockTypes/ColorBlock/styles";

interface Props {
  block: ColorBlock;
  plate: Plate;
  editable: boolean;
}
export function ColorBlockContent({ block, plate, editable }: Props) {
  const selection = plate.observe((state) => state.selection);
  const isSelected = selection.includes(block.snapshot.id);
  const color = block.observe((state) => state.hex);

  return (
    <StyledColorBlockContent
      onMouseDown={(e) => {
        // Prevent block from being unselected when clicking on color picker
        if (isSelected) {
          e.stopPropagation();
        }
      }}
      color={color}
    >
      {isSelected && editable && (
        <ColorPicker type="color" onChange={(e) => block.changeColor(e.target.value)} value={color} />
      )}
    </StyledColorBlockContent>
  );
}
